export enum GROUP_KIND {
    "part" = 1,
    "labor",
    "expense"
}
